import styled from 'styled-components';

export const PageWrap = styled.div`
  background-color: ${Styles.color.white};
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;

  ${Styles.desktop`
    padding-top: 10vh;
  `}
`;

/** future refactoring - share this with accounts navigation? */
export const InnerBox = styled.div`
  background-color: ${Styles.color.white};
  flex: 1;

  /* this prevents margin-collapse between this wrapper and child elements */
  overflow: auto;

  ${Styles.desktop`
    max-width: ${Styles.layout.smallerSectionMaxWidth};
    background-color: ${Styles.color.white};
    border-radius: ${Styles.borderRadius};
    box-shadow: ${Styles.boxShadow};
    min-height: 0;
`}
`;

export const ContentWrap = styled.div`
  margin: 2rem auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  > * {
    width: 90%;
  }

  /* prevent margin collapsing from pushing title tags to the top edge of this container */
  overflow: auto;
`;

export const PageHeading = styled.h1`
  font-size: 2rem;
  font-weight: ${Styles.fontWeight.black};
  font-family: ${Styles.fontFamily.body};
  line-height: 1.25;
  text-align: center;

  small {
    font-size: 1.5rem;
  }
`;

export const SectionHeading = styled.h2`
  text-align: center;
  font-size: 1.5rem;
  font-weight: ${Styles.fontWeight.black};
  font-family: ${Styles.fontFamily.body};
  margin-top: 0;
`;

export const NeedHelpHeading = styled(SectionHeading)`
  font-size: 1.2rem;
`;

export const ContentLoadingContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextBlock = styled.div`
  font-family: ${Styles.fontFamily.body};
  text-decoration: none;
  padding: 4px 0;
  display: flex;
  align-items: center;
  text-align: left;
  width: 90%;
  margin: 0 auto;
`;
